<ion-header class="modal-header">
  <ion-toolbar color="primary">
    <ion-title>Legenda da agenda</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Fechar">
        <ion-icon class="icon-style" name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content">
  <!-- Intro -->
  <div class="intro-section">
    <div class="intro-icon">
      <ion-icon name="information-circle-outline"></ion-icon>
    </div>
    <h1>Como ler a agenda</h1>
    <p>Cada cor de card e cada cor de pílula tem um significado. Aqui está a legenda.</p>
  </div>

  <!-- Cores dos cards (por tipo de slot) -->
  <section class="legend-section">
    <h2>🎨 Cores dos cards</h2>
    <p class="section-hint">A cor de fundo e da borda lateral indica o tipo do horário.</p>

    <div class="legend-grid">
      @for (item of typeLegends; track item.cssClass) {
        <div class="legend-item">
          <div class="legend-swatch" [class]="'legend-swatch--' + item.cssClass">
            <div class="legend-swatch__bar"></div>
            <span class="legend-swatch__label">{{ item.label }}</span>
          </div>
          <p class="legend-text">{{ item.description }}</p>
        </div>
      }
    </div>
  </section>

  <!-- Estados das pílulas (atletas inscritos) -->
  <section class="legend-section">
    <h2>👥 Pílulas de atletas</h2>
    <p class="section-hint">
      Cada atleta inscrito vira uma pílula colorida com o status do pagamento.
    </p>

    <div class="attendee-grid">
      @for (item of attendeeLegends; track item.cssClass) {
        <div class="attendee-item">
          <span class="attendee-chip" [class]="'attendee-chip--' + item.cssClass">
            @if (item.cssClass === 'empty') {
              <ion-icon name="add-outline" aria-hidden="true"></ion-icon>
              Vaga
            } @else {
              {{ item.label }}
            }
          </span>
          <p class="legend-text">{{ item.description }}</p>
        </div>
      }
    </div>
  </section>

  <!-- Outros símbolos -->
  <section class="legend-section">
    <h2>🔣 Outros símbolos</h2>
    <div class="symbol-list">
      <div class="symbol-item">
        <span class="symbol-icon"><ion-icon name="add-outline"></ion-icon></span>
        <div>
          <strong>Ícone "+"</strong>
          <span>Slot disponível — toque para criar.</span>
        </div>
      </div>
      <div class="symbol-item">
        <span class="symbol-icon"><ion-icon name="lock-closed-outline"></ion-icon></span>
        <div>
          <strong>Cadeado 🔒</strong>
          <span>Slot bloqueado (manutenção, almoço, etc).</span>
        </div>
      </div>
      <div class="symbol-item">
        <span class="symbol-icon"><strong>4/4</strong></span>
        <div>
          <strong>Contador X/Y</strong>
          <span>Quantos atletas estão inscritos / capacidade total.</span>
        </div>
      </div>
      <div class="symbol-item">
        <span class="symbol-icon"><strong>×3</strong></span>
        <div>
          <strong>Multiplicador "×N"</strong>
          <span>Mesmo atleta tem múltiplas inscrições no slot.</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Dica -->
  <div class="tip-section">
    <div class="tip-icon">
      <ion-icon name="bulb-outline"></ion-icon>
    </div>
    <div class="tip-content">
      <h3>💡 Dica</h3>
      <p>
        Toque num slot disponível para criar uma reserva ou bloquear. Toque num slot ocupado para
        ver detalhes.
      </p>
    </div>
  </div>

  <!-- Action -->
  <div class="action-section">
    <ion-button expand="block" size="large" (click)="dismiss()">
      <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
      Entendi
    </ion-button>
  </div>
</ion-content>
